import { Beaker } from "lucide-react";

/** Visible sticker shown anywhere the demo business is rendered publicly
 *  (discovery card, mini-site header, simple profile). Keeps demo data
 *  obviously labelled so viewers don't mistake it for a real rental.
 *
 *  Variants:
 *    - "default" (amber pill), for cards / general use
 *    - "header"  (white-on-glass), for use over a themed nav background
 *    - "ribbon"  (large, for hero overlay)
 */
export default function DemoBadge({
  variant = "default",
  size = "sm",
  className = "",
  testId = "demo-badge",
}) {
  const base =
    "inline-flex items-center gap-1 font-semibold rounded-full border whitespace-nowrap";
  const sizeMap = {
    xs: "text-[10px] px-1.5 py-0.5 gap-0.5",
    sm: "text-[11px] px-2 py-0.5",
    md: "text-xs px-2.5 py-1",
    lg: "text-sm px-3 py-1.5",
  };
  const variantMap = {
    default: "bg-amber-100 text-amber-900 border-amber-300",
    header:  "bg-white/95 text-amber-800 border-amber-300 shadow-sm",
    ribbon:  "bg-amber-500 text-white border-amber-600 shadow-md",
    soft:    "bg-amber-50 text-amber-800 border-amber-200",
  };
  return (
    <span
      data-testid={testId}
      title="This is sample/demo data used to show how ConfirmPH works."
      className={`${base} ${sizeMap[size] || sizeMap.sm} ${variantMap[variant] || variantMap.default} ${className}`}
    >
      <Beaker className="w-3 h-3" aria-hidden />
      Demo Business
    </span>
  );
}
